import type { StrokeTool } from '../types/app.js';

/** Completed drawings have a tool-specific point count. Drafts can be shorter. */
export function hasCompleteStrokePoints(tool: StrokeTool, points: readonly unknown[]): boolean {
  switch (tool) {
    case 'marker':
    case 'text': return points.length === 1;
    case 'circle': return points.length === 2;
    case 'polygon': return points.length >= 3;
    case 'freehand': return points.length >= 1;
    case 'line':
    case 'arrow': return points.length >= 2;
  }
}
